<template>
	<div
		class="side-bar-drawer-knob"
		@click="setIsSideBarDrawerOpen(!isSideBarDrawerOpen)"
		:class="[drawerDir, { 'is-show-knob': isShowKnob }]"
	>
		<div class="side-bar-drawer-knob-content">
			<SideBarDrawerKnobSVG />
			<div class="knob-arrow-container">
				<KnobArrow :isOpen="isSideBarDrawerOpen" />
			</div>
		</div>
	</div>
</template>

<script>
import KnobArrow from './KnobArrow.vue';
import SideBarDrawerKnobSVG from './assets/SideBarDrawerKnobSVG.vue';
import { SideBarDrawerDirection, isValidSideBarDrawerDirection } from './helpers';
import { setIsSideBarDrawerOpen } from '@/store/modules/sideBarDrawer/actions';
import { isSideBarDrawerOpen, isShowKnob } from '@/store/modules/sideBarDrawer/getters';
import { mapActionsShorthand, mapGettersShorthand } from '@/store/utils/mappers';
export default {
	name: 'SideBarDrawerKnob',
	props: {
		drawerDir: { type: String, default: SideBarDrawerDirection.Left, validator: isValidSideBarDrawerDirection },
	},
	components: {
		KnobArrow,
		SideBarDrawerKnobSVG,
	},
	methods: {
		...mapActionsShorthand({ setIsSideBarDrawerOpen }),
	},
	computed: {
		...mapGettersShorthand({ isSideBarDrawerOpen, isShowKnob }),
	},
};
</script>
<style lang="scss" scoped>
.side-bar-drawer-knob {
	position: absolute;
	top: 50%;
	// transition-delay: 6s;
	transition: 0.5s;
	z-index: -10;

	&.left {
		left: 8px;
		transform: translate(100%, -50%);
		&.is-show-knob {
			transform: translate(-100%, -50%);
		}
	}
	&.right {
		right: 8px;
		transform: translate(-100%, -50%);
		&.is-show-knob {
			transform: translate(100%, -50%);
		}
	}

	&.is-show-knob {
		transition: 0.6s;
		transition-delay: 0.2s;
	}

	&.left {
		.side-bar-drawer-knob-content {
			.knob-arrow-container {
				left: 15%;
				padding: 6px 14px 6px 13px;
			}
		}
	}
	&.right {
		.side-bar-drawer-knob-content {
			transform: rotate(180deg);
			.knob-arrow-container {
				right: 15%;
				padding: 6px 13px 6px 14px;
			}
		}
	}

	.side-bar-drawer-knob-content {
		position: relative;

		.knob-arrow-container {
			position: absolute;
			top: 41%;
			background-color: var(--page-background);
			cursor: pointer;
		}

		&:hover {
			$hover-color: #f7f9fb;
			cursor: pointer;
			transition: 0.3s;

			::v-deep {
				.side-bar-drawer-knob-svg {
					path {
						fill: $hover-color;
						transition: 0.3s;
					}
				}

				.knob-arrow {
					path,
					line {
						stroke: #354f6d;
					}
				}
			}

			.knob-arrow-container {
				transition: 0.4s;
				background-color: $hover-color;
			}
		}
	}
}
</style>
